import { VolumeUnits, WeightUnits } from '@emi/shared/models';

export default function convertMetric(
    value: number,
    inputType: VolumeUnits | WeightUnits | string,
    expectedType: VolumeUnits | WeightUnits | string
) {
    let convertedUnit: number | null = null;

    switch (inputType) {
        case 'ml':
            handleVolumeML();
            break;

        case 'gal':
            handleVolumeGAL();
            break;

        case 'cl':
            handleVolumeCL();
            break;

        case 'l':
            handleVolumeL();
            break;

        case 'pt':
            handleVolumePT();
            break;

        case 'fl oz':
            handleVolumeFLOZ();
            break;

        case 'oz':
            handleWeightOZ();
            break;

        case 'mg':
            handleWeightMG();
            break;

        case 'kg':
            handleWeightKg();
            break;

        case 'lb':
            handleWeightLB();
            break;

        case 'g':
            handleWeightG();
            break;

        default:
            break;
    }

    function handleVolumeML() {
        switch (expectedType) {
            case 'gal':
                convertedUnit = mlToGal(value);
                break;

            case 'cl':
                convertedUnit = mlToCl(value);
                break;

            case 'l':
                convertedUnit = mlToL(value);
                break;

            case 'pt':
                convertedUnit = mlToPt(value);
                break;

            case 'fl oz':
                convertedUnit = mlToFlOz(value);
                break;

            default:
                break;
        }
    }

    function handleVolumeGAL() {
        switch (expectedType) {
            case 'ml':
                convertedUnit = galToMl(value);
                break;

            case 'cl':
                convertedUnit = galToCl(value);
                break;

            case 'l':
                convertedUnit = galToL(value);
                break;

            case 'pt':
                convertedUnit = galToPt(value);
                break;

            case 'fl oz':
                convertedUnit = galToFlOz(value);
                break;

            default:
                break;
        }
    }

    function handleVolumeCL() {
        switch (expectedType) {
            case 'ml':
                convertedUnit = clToMl(value);
                break;

            case 'gal':
                convertedUnit = clToGal(value);
                break;

            case 'l':
                convertedUnit = clToL(value);
                break;

            case 'pt':
                convertedUnit = clToPt(value);
                break;

            case 'fl oz':
                convertedUnit = clToFlOz(value);
                break;

            default:
                break;
        }
    }

    function handleVolumeL() {
        switch (expectedType) {
            case 'ml':
                convertedUnit = lToMl(value);
                break;

            case 'gal':
                convertedUnit = lToGal(value);
                break;

            case 'cl':
                convertedUnit = ltoCl(value);
                break;

            case 'pt':
                convertedUnit = lToPt(value);
                break;

            case 'fl oz':
                convertedUnit = lToFlOz(value);
                break;

            default:
                break;
        }
    }

    function handleVolumePT() {
        switch (expectedType) {
            case 'ml':
                convertedUnit = ptToMl(value);
                break;

            case 'gal':
                convertedUnit = ptToGal(value);
                break;

            case 'cl':
                convertedUnit = ptToCl(value);
                break;

            case 'l':
                convertedUnit = ptToL(value);
                break;

            case 'fl oz':
                convertedUnit = ptToFlOz(value);
                break;

            default:
                break;
        }
    }

    function handleVolumeFLOZ() {
        switch (expectedType) {
            case 'ml':
                convertedUnit = flozToMl(value);
                break;

            case 'gal':
                convertedUnit = flozToGal(value);
                break;

            case 'cl':
                convertedUnit = flozToCl(value);
                break;

            case 'l':
                convertedUnit = flozToL(value);
                break;

            case 'pt':
                convertedUnit = flozToPt(value);
                break;

            default:
                break;
        }
    }

    function handleWeightOZ() {
        switch (expectedType) {
            case 'mg':
                convertedUnit = OzToMg(value);
                break;

            case 'kg':
                convertedUnit = OzToKg(value);
                break;

            case 'lb':
                convertedUnit = OzToLb(value);
                break;

            case 'g':
                convertedUnit = OzToG(value);
                break;

            default:
                break;
        }
    }

    function handleWeightMG() {
        switch (expectedType) {
            case 'oz':
                convertedUnit = MgToOz(value);
                break;

            case 'kg':
                convertedUnit = MgToKg(value);
                break;

            case 'lb':
                convertedUnit = MgToLb(value);
                break;

            case 'g':
                convertedUnit = MgtoG(value);
                break;

            default:
                break;
        }
    }

    function handleWeightKg() {
        switch (expectedType) {
            case 'oz':
                convertedUnit = KgToOz(value);
                break;

            case 'mg':
                convertedUnit = KgToMg(value);
                break;

            case 'lb':
                convertedUnit = KgToLb(value);
                break;

            case 'g':
                convertedUnit = KgtoG(value);
                break;

            default:
                break;
        }
    }

    function handleWeightLB() {
        switch (expectedType) {
            case 'oz':
                convertedUnit = LbToOz(value);
                break;

            case 'mg':
                convertedUnit = LbToMg(value);
                break;

            case 'kg':
                convertedUnit = LbToKg(value);
                break;

            case 'g':
                convertedUnit = LbToG(value);
                break;

            default:
                break;
        }
    }

    function handleWeightG() {
        switch (expectedType) {
            case 'oz':
                convertedUnit = GToOz(value);
                break;

            case 'mg':
                convertedUnit = GToMg(value);
                break;

            case 'kg':
                convertedUnit = GToKg(value);
                break;

            case 'lb':
                convertedUnit = GToLb(value);
                break;

            default:
                break;
        }
    }

    // Helper Functions for ml to others
    function mlToGal(value: number) {
        return value / 3785;
    }
    function mlToCl(value: number) {
        return value / 10;
    }
    function mlToL(value: number) {
        return value / 1000;
    }
    function mlToPt(value: number) {
        return value / 568.3;
    }
    function mlToFlOz(value: number) {
        return value / 29.574;
    }

    // Helper Functions for gal to others
    function galToMl(value: number) {
        return value * 3785;
    }
    function galToCl(value: number) {
        return value * 378.5;
    }
    function galToL(value: number) {
        return value * 3.785;
    }
    function galToPt(value: number) {
        return value * 6.661;
    }
    function galToFlOz(value: number) {
        return value * 128;
    }

    // Helper Functions for cl to others
    function clToMl(value: number) {
        return value * 10;
    }
    function clToGal(value: number) {
        return value / 378.5;
    }
    function clToL(value: number) {
        return value / 100;
    }
    function clToPt(value: number) {
        return value * 227800;
    }
    function clToFlOz(value: number) {
        return value / 2.957;
    }

    // Helper Functions for l to others
    function lToMl(value: number) {
        return value * 1000;
    }
    function lToGal(value: number) {
        return value / 3.785;
    }
    function ltoCl(value: number) {
        return value * 100;
    }
    function lToPt(value: number) {
        return value * 1.76;
    }
    function lToFlOz(value: number) {
        return value * 33.814;
    }

    // Helper Functions for pt to others
    function ptToMl(value: number) {
        return value * 568.3;
    }
    function ptToGal(value: number) {
        return value / 6.661;
    }
    function ptToCl(value: number) {
        return value * 47.3176473;
    }
    function ptToL(value: number) {
        return value / 1.76;
    }
    function ptToFlOz(value: number) {
        return value * 16;
    }

    // Helper Functions for fl-oz to others
    function flozToMl(value: number) {
        return value * 29.574;
    }
    function flozToGal(value: number) {
        return value / 128;
    }
    function flozToCl(value: number) {
        return value * 2.957;
    }
    function flozToL(value: number) {
        return value / 33.814;
    }
    function flozToPt(value: number) {
        return value * 19.215;
    }

    // Helper Functions for oz to others
    function OzToMg(value: number) {
        return value * 28350;
    }
    function OzToKg(value: number) {
        return value / 35.274;
    }
    function OzToLb(value: number) {
        return value / 16;
    }
    function OzToG(value: number) {
        return value * 28.35;
    }

    // Helper Functions for mg to others
    function MgToOz(value: number) {
        return value / 28350;
    }
    function MgToLb(value: number) {
        return value / 453600;
    }
    function MgtoG(value: number) {
        return value / 1000;
    }
    function MgToKg(value: number) {
        return value / 1000000;
    }

    // Helper Functions for Kg to others
    function KgToOz(value: number) {
        return value * 35.274;
    }
    function KgToLb(value: number) {
        return value * 2.205;
    }
    function KgtoG(value: number) {
        return value * 1000;
    }
    function KgToMg(value: number) {
        return value * 1000000;
    }

    // Helper Functions for lb to others
    function LbToOz(value: number) {
        return value * 16;
    }
    function LbToKg(value: number) {
        return value / 2.205;
    }
    function LbToMg(value: number) {
        return value * 453600;
    }
    function LbToG(value: number) {
        return value * 453.6;
    }

    // Helper Functions for g to others
    function GToOz(value: number) {
        return value / 28.35;
    }
    function GToMg(value: number) {
        return value * 1000;
    }
    function GToKg(value: number) {
        return value / 1000;
    }
    function GToLb(value: number) {
        return value / 453.6;
    }

    // return final converted value
    return convertedUnit;
}
